// src/App.js
import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './components/Login';
import RegistraPresenza from './components/RegistraPresenza';
import DashboardPresenze from './components/DashboardPresenze';
import AdminDashboard from './components/AdminDashboard';
import ArchivioPresenze from './components/ArchivioPresenze';
import GestioneUtenti from './components/GestioneUtenti';
import GestioneSedi from './components/GestioneSedi';
import GestionePresenze from './components/GestionePresenze';
import Navbar from './components/Navbar';
import TotaliOreMensili from './components/TotaliOreMensili';
import { getToken, getUserInfo, isTokenExpired } from './utils/auth';

function App() {
  const [token, setToken] = useState(() => getToken());
  const [ruolo, setRuolo] = useState(null);
  const [utente, setUtente] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const savedToken = getToken();
    if (savedToken && !isTokenExpired()) {
      const user = getUserInfo();
      setUtente(user);
      setRuolo(user?.ruolo ?? null);
      setToken(savedToken);
    } else {
      localStorage.removeItem('token');
      setToken(null);
      setRuolo(null);
      setUtente(null);
    }
    setLoadingAuth(false);
  }, [token]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setRuolo(null);
    setUtente(null);
  };

  if (loadingAuth) {
    return null;
  }

  return (
    <div style={{ padding: '20px' }}>
      {token && <Navbar onLogout={handleLogout} ruolo={ruolo} utente={utente} />}

      <Routes>
        {!token ? (
          <Route path="*" element={<Login setToken={setToken} />} />
        ) : ruolo === 'admin' ? (
          <>
            <Route path="/" element={<AdminDashboard />} />
            <Route path="/archivio" element={<ArchivioPresenze />} />
            <Route path="/utenti" element={<GestioneUtenti ruoloCorrente={ruolo} />} />
            <Route path="/gestione-presenze" element={<GestionePresenze ruoloCorrente={ruolo} />} />
            <Route path="/totali-ore" element={<TotaliOreMensili />} />
            <Route path="/sedi" element={<GestioneSedi />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <>
            <Route
              path="/"
              element={
                <>
                  {ruolo !== 'admin' && <RegistraPresenza />}
                  <hr />
                  <DashboardPresenze />
                </>
              }
            />
            {ruolo === 'responsabile' && (
              <Route path="/utenti" element={<GestioneUtenti ruoloCorrente={ruolo} />} />
            )}
            {ruolo === 'responsabile' && (
              <Route path="/gestione-presenze" element={<GestionePresenze ruoloCorrente={ruolo} />} />
            )}
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;
